<template>
  <div>
    <div v-if="loading">
      <b-spinner
                 variant="primary"
                 style="width: 3rem; height: 3rem"
                 label="Large Spinner"></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <div class="border p-2 mb-3" v-if="quotation.job">
          <div class="row">
            <div class="col-auto">
              <span class="bg-primary text-white px-3 font-size-26">
                {{ quotation.job.job_number }}</span>
            </div>
            <div class="col">
              <p class="text-muted mt-2 mb-0" v-if="quotation.job.manufacture">
                {{ quotation.job.manufacture.description }} -
                {{ quotation.job.device_type.description }}
                <span v-if="quotation.job.device_model">
                  <br />
                  <strong>{{ quotation.job.device_model.code }}</strong> -
                  {{ quotation.job.imei_in ? quotation.job.imei_in : quotation.job.serial_in }}
                </span>
              </p>
            </div>
          </div>
        </div>

        <b-tabs>
          <b-tab title="Quote" class="pt-3">



            <span v-if="quotation.quotation_items">
              <table class="table table-sm border mt-2">
                <tr class="bg-dark text-white font-size-11 font-weight-bold">
                  <td width="18%"> CODE</td>
                  <td width="25%"> DESCRIPTION</td>
                  <td width="10%"> QUANTITY</td>
                  <td width="18%" class="text-right">
                    AMOUNT
                  </td>
                  <td width="18%" class="text-right">
                    TOTAL
                  </td>
                  <td width="11%" class="text-right">

                  </td>
                </tr>

                <tr v-for="(line,i) in updatedQuotation.quotation_items" :key="line.id">
                  <td>
                    {{ line.code }}
                  </td>
                  <td>
                    {{ line.description }}
                  </td>
                  <td>
                    {{ line.quantity }}
                  </td>
                  <td class="text-right">
                    <strong> 

                      <input class="form-control" style="height: 30px;" v-model="line.amount" type="number" min="0.01" max="1000000"  debounce="500" @change="calculate"/>
                    </strong>
                  </td>
                  <td class="text-right">
                    <strong> {{ line.line_total_amount }}</strong>
                  </td>
                  <td class="text-right">
                    <span
                          v-b-tooltip.hover
                          style="cursor: pointer"
                          title="Delete"
                          @click="removeItem(i)"
                          class="text-danger table-action-icon">
                      <i class="lni lni-trash"></i>
                    </span>
                  </td>
                </tr>

                <tr>
                  <td class="border-0"></td>
                  <td class="border-0"></td>
                  <td class="border-0"></td>
                  <td class="border-0"></td>
                  <td class="border-0"></td>
                  <td class="border-0"></td>
                </tr>


                <tr>
                  <td colspan="4" class="bg-light"></td>
                  <td class="text-right bg-light lead">
                    <strong>TOTAL DUE</strong>
                  </td>
                  <td class="text-right bg-light lead">
                    <strong>{{ updatedQuotation.total_amount }}</strong>
                  </td>
                </tr>


              </table>

              
                <b-card class="border">

                  <form-group label="Description">
                    <input
                      type="text"
                      v-model="newItem.description"
                      class="form-control"
                      max="150"
                    />
                  </form-group>

                  <form-group label="Quantity">
                    <input
                      type="number"
                      v-model="newItem.quantity"
                      step="1"
                      min="1"
                      max="100"
                      class="form-control"
                    />
                  </form-group>

                  <form-group label="Amount">
                    <input
                      type="number"
                      v-model="newItem.amount"
                      min="0.01"
                      max="1000000"
                      class="form-control"
                    />
                  </form-group>



                  <b-button
                  class="float-right"
                    variant="success"
                    size="sm"
                    @click="addItem()"
                    >Add Item</b-button
                  >
                </b-card>
          

            </span>

            <b-button
            class="my-3"
                      variant="primary"
                      @click="handleSubmit()">Update</b-button>
          </b-tab>

          <b-tab title="Job" class="pt-3" v-if="quotation && quotation.job_id">
            <job-minimal :id="quotation.job_id"></job-minimal>
          </b-tab>
          <b-tab
                 title="Client"
                 class="pt-3"
                 v-if="quotation && quotation.client_id">
            <client-show :id="quotation.client_id"></client-show>
          </b-tab>
          <b-tab
                 title="Partner"
                 class="pt-3"
                 v-if="quotation && quotation.partner_id">
            <partner-show :id="quotation.partner_id"></partner-show>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import quotationRepo from "@/api/repos/quotationRepo";
import jobMinimal from "@/views/modules/jobs/enquiryMinimal";
import clientShow from "@/views/modules/clients/show";
import partnerShow from "@/views/modules/partners/show";
//import tableRow from "@/components/common/TableRow";
import formGroup from "@/components/common/FormGroup";

export default {
  props: ["id"],

  components: {
    // tableRow,
    jobMinimal,
    clientShow,
    partnerShow,
    formGroup,
  },

  mounted() {
    this.getQuotation();
  },

  data() {
    return {
      loading: false,
      submitStatus: null,
      newItem:{
        code:'FF',
        quantity:1
      },
      quotation: {},
      updatedQuotation: {
        total_amount: 0,
        quotation_items: []
      }
    };
  },

  validations: {
    quotation: {
    },
  },

  methods: {
    async getQuotation() {
      try {
        this.loading = true;
        let { data } = await quotationRepo.get(this.id);
        this.quotation = data.quotation;

        this.updatedQuotation.id = this.quotation.id;

        this.quotation.quotation_items.forEach((i) => {
          this.updatedQuotation.quotation_items.push({
            id: i.id,
            part_id: i.part_id,
            quantity: i.quantity,
            code: i.code,
            description: i.description,
            amount: parseFloat(i.line_amount) + parseFloat(i.line_vat_amount),
            line_total_amount: i.line_total_amount
          });
          this.updatedQuotation.total_amount += parseFloat(i.line_total_amount);
        })
        this.calculate();
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    async handleSubmit() {

      if(this.updatedQuotation.quotation_items.length == 0){
        this.$root.$bvToast.toast("Form Errors", {
            title: "Errors on form data",
            autoHideDelay: 3000,
            variant: "danger",
          });
        return false;
      }

      this.loading = true;
      this.submitStatus = "PENDING";

      try {
        await quotationRepo.update(this.updatedQuotation);
        this.$emit("reviewed");
      } catch (error) {
        this.loading = false;
        console.log(error);
        if (error.response.status === 422) {
          this.errors = error.response.data.errors;
          console.log(this.errors);
          this.$root.$bvToast.toast("Form Errors", {
            title: "Errors on form data",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      } finally {
        this.submitStatus = null;
      }
    },
    calculate() {
      this.updatedQuotation.total_amount = 0;

      this.updatedQuotation.quotation_items.forEach((i) => {
        i.line_total_amount = parseFloat(i.quantity) * parseFloat(i.amount);
        this.updatedQuotation.total_amount += parseFloat(i.line_total_amount);
      });

    },
    
    removeItem(index) {
      this.updatedQuotation.quotation_items = this.updatedQuotation.quotation_items.filter((x, i) => i != index);
      this.calculate();
    },

    addItem() {

      if(this.newItem.amount == '' || this.newItem.amount == null || this.newItem.description == '' || this.newItem.description == null){
        this.$root.$bvToast.toast("Form Errors", {
            title: "Errors on form data",
            autoHideDelay: 3000,
            variant: "danger",
          });
        return false;
      }

      this.updatedQuotation.quotation_items.push({
        id:Date.now(),
        code:this.newItem.code,
        description:this.newItem.description,
        amount:this.newItem.amount,
        quantity:this.newItem.quantity
      })
      this.calculate();
      this.newItem = {
        code:'FF',
        quantity:1
      }
    }
  },

};
</script>
